function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodBarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.23 13.516l-.708 2.9 1.943.473.823-3.373h3.928l-6.28 7.458-6.28-7.458h6.573zm8.9-.356a1 1 0 00-.764-1.644h-5.59l1.582-6.489 3.977-1.06-.515-1.933L18.696 3.4l-1.98 8.116h-9.21a1 1 0 00-.764 1.644l8.194 9.732V28H11.65v2h8.574v-2h-3.287v-5.108l8.194-9.732z",
    fill: props.color
  }));
}

export default SvgIconFoodBarFilled;